/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/tillsammans/"

const TILLSAMMANS: CommunityData = {
  code: "tillsammans",
  inviteCode: "tillsammans",
  name: "Tillsammans",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/till-040`,
  waitlist: false,
  socials: {},
  styles: {
    global: {
      counterColor: "#101010",
      werzLogoColor: "#101010",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[188px] h-[22px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[188px] h-[22px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#fbf2d5",
      asideBg: "#fbf2d5",
      // Custom override: no gap, no padding on the aside — border only
      asideStyles: "!p-0 !gap-0 border-r-2 border-[#101010]",
      contentBg: "#fbf2d5",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['RecoletaRegular']",
      primaryButton:
        "bg-[#000000] border-2 border-[#000000] rounded-lg px-[18px] !text-[#ffffff] font-['TAN-NIMBUSRegular'] !text-[14px] uppercase text-left !h-[50px] sm:!h-[50px]",
    },
    navigation: {
      iconsColor: "#222222",
      sideBarSeparator: "border-r-[2px] border-[#101010]",
      separator: "border-[#101010]",
      item: "text-[#222222] font-['RecoletaMedium'] text-[17px] leading-[100%] text-center gap-x-[10px] text-opacity-50 border-b-2 border-[#101010] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#fbf2d5] border-2 border-[#101010] rounded-2xl !pb-8 overflow-hidden",
      titles: "text-[#000000] font-['RecoletaSemiBold'] text-[32px] leading-[110%] text-left",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#333333] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-2 border-[#101010]",
        sectionTitle:
          "text-[#000000] font-['RecoletaSemiBold'] text-[32px] leading-[110%] text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !h-[256px] relative overflow-hidden rounded-lg",
          media: "w-full !h-[256px] object-cover rounded-lg",
          placeholderMedia: "w-full !h-[256px] bg-gray-400 rounded-lg",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#000000] font-['RecoletaSemiBold'] text-[16px] leading-[110%] text-left",
          subtitle:
            "text-[#333333] font-['RecoletaRegular'] text-[12px] leading-[120%] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-2 border-[#101010]",
        sectionTitle:
          "text-[#000000] font-['RecoletaSemiBold'] text-[32px] leading-[110%] text-left pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer:
            "w-full sm:!w-[228px] !h-[128px] sm:flex-shrink-0 relative overflow-hidden rounded-lg",
          media: "w-full !h-[128px] object-cover rounded-lg",
          placeholderMedia: "w-full !h-[128px] bg-gray-400 rounded-lg",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#000000] font-['RecoletaSemiBold'] text-[16px] leading-[110%] text-left",
          subtitle:
            "text-[#333333] font-['RecoletaRegular'] text-[12px] leading-[120%] text-left mt-2",
          location:
            "text-[#333333] font-['RecoletaRegular'] text-[12px] leading-[120%] text-left mt-1",
          date: "text-[#333333] font-['RecoletaRegular'] text-[12px] leading-[120%] text-left mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#000000] font-['RecoletaSemiBold'] text-[26px] leading-[110%] text-left",
        text: "text-[#101010] font-['RecoletaRegular'] text-[16px] leading-[120%] text-left",
        customShopImageStyle: "rounded-lg",
        sectionTitle:
          "text-[#000000] font-['RecoletaSemiBold'] text-[32px] leading-[110%] text-left !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container:
        "flex flex-col !bg-[#fbf2d5] border-2 border-[#101010] rounded-2xl !pb-8 overflow-hidden",
      eventInfo: {
        container:
          "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b-2 border-[#101010]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0 rounded-lg",
        title: "text-[#000000] font-['RecoletaSemiBold'] text-[32px] leading-[110%] text-left",
        subtitle:
          "text-[#333333] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left mb-4 mt-2",
        button:
          "bg-[#000000] border-2 border-[#000000] rounded-lg px-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['TAN-NIMBUSRegular'] !text-[14px] uppercase text-left !h-[50px] sm:!h-[50px] gap-y-[6px]",
        questions: "text-[14px] leading-[120%] text-left !text-[#333333]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-2 border-[#101010]",
        header: "text-[#000000] font-['RecoletaSemiBold'] text-[26px] leading-[110%] text-left",
        text: "text-[#101010] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-2 border-[#101010]",
        header: "text-[#000000] font-['RecoletaSemiBold'] text-[26px] leading-[110%] text-left",
        text: "text-[#101010] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden rounded-lg gap-y-[10px]",
        mapPinColor: "#101010",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#000000] font-['RecoletaSemiBold'] text-[26px] leading-[110%] text-left",
        text: "text-[#101010] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left",
      },
      tickets: {
        header:
          "text-[#000000] font-['RecoletaSemiBold'] text-[26px] leading-[110%] text-left px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#fbf2d5] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#fbf2d5] !border-2 !border-[#101010] !rounded-lg px-[12px] text-[#000000] font-['TAN-NIMBUSRegular'] text-[11px] leading-[100%] uppercase text-center flex items-center justify-center !w-fit !h-[40px] sm:!h-[40px]",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto bg-[#ffffff00] border-b border-[#101010] overflow-hidden py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['RecoletaSemiBold'] text-[16px] leading-[110%] text-left mb-1",
          description:
            "text-[#333333] font-['RecoletaRegular'] text-[14px] leading-[120%] text-left mb-1 flex flex-row",
          price: "text-[#333333] font-['RecoletaSemiBold'] text-[16px] leading-[110%] text-left",
          status: "text-[#333333] font-['RecoletaSemiBold'] text-[16px] leading-[110%] text-left",
          counterContainer:
            "bg-[#fbf2d5] !border-2 !border-[#101010] !rounded-lg !px-[12px] gap-x-[16px] !w-fit !h-[40px] sm:!h-[40px]",
          quantity:
            "text-[#000000] font-['RecoletaSemiBold'] text-[16px] leading-[100%] uppercase text-center flex items-center justify-center",
          plusMinusColor: "#000000",
          button:
            "bg-[#fbf2d5] !border-2 !border-[#101010] !rounded-lg px-[12px] text-[#000000] font-['TAN-NIMBUSRegular'] text-[11px] leading-[100%] uppercase text-center flex items-center justify-center !w-fit !h-[40px] sm:!h-[40px]",
        },
      },
    },
  },
}

export default TILLSAMMANS
